'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeatureFlagsContext = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/forbid-prop-types */
var FeatureFlagsContext = exports.FeatureFlagsContext = _react2.default.createContext();

var FeatureFlagsProvider = function FeatureFlagsProvider(_ref) {
  var children = _ref.children,
      getFeatureFlag = _ref.getFeatureFlag,
      trackEncounterFlag = _ref.trackEncounterFlag;

  return _react2.default.createElement(
    FeatureFlagsContext.Provider,
    {
      value: { getFeatureFlag: getFeatureFlag, trackEncounterFlag: trackEncounterFlag }
    },
    children
  );
};

FeatureFlagsProvider.propTypes = {
  getFeatureFlag: _propTypes.func.isRequired,
  trackEncounterFlag: _propTypes.func,
  children: _propTypes.node.isRequired
};

FeatureFlagsProvider.defaultProps = {
  trackEncounterFlag: function trackEncounterFlag() {
    /* noop */
  }
};

exports.default = FeatureFlagsProvider;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm92aWRlci5qcyJdLCJuYW1lcyI6WyJGZWF0dXJlRmxhZ3NDb250ZXh0IiwiY3JlYXRlQ29udGV4dCIsIkZlYXR1cmVGbGFnc1Byb3ZpZGVyIiwiY2hpbGRyZW4iLCJnZXRGZWF0dXJlRmxhZyIsInRyYWNrRW5jb3VudGVyRmxhZyIsInByb3BUeXBlcyIsImlzUmVxdWlyZWQiLCJkZWZhdWx0UHJvcHMiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFDQTs7OztBQUNBOzs7O0FBRkE7QUFJTyxJQUFNQSxvREFBc0IsZ0JBQU1DLGFBQU4sRUFBNUI7O0FBRVAsSUFBTUMsdUJBQXVCLFNBQXZCQSxvQkFBdUIsT0FJdkI7QUFBQSxNQUhKQyxRQUdJLFFBSEpBLFFBR0k7QUFBQSxNQUZKQyxjQUVJLFFBRkpBLGNBRUk7QUFBQSxNQURKQyxrQkFDSSxRQURKQSxrQkFDSTs7QUFDSixTQUNFO0FBQUMsdUJBQUQsQ0FBcUIsUUFBckI7QUFBQTtBQUNFLGFBQU8sRUFBRUQsOEJBQUYsRUFBa0JDLHNDQUFsQjtBQURUO0FBR0dGO0FBSEgsR0FERjtBQU9ELENBWkQ7O0FBY0FELHFCQUFxQkksU0FBckIsR0FBaUM7QUFDL0JGLGtCQUFnQixnQkFBS0csVUFEVTtBQUUvQkYscUNBRitCO0FBRy9CRixZQUFVLGdCQUFLSTtBQUhnQixDQUFqQzs7QUFNQUwscUJBQXFCTSxZQUFyQixHQUFvQztBQUNsQ0gsc0JBQW9CLDhCQUFNO0FBQ3hCO0FBQ0Q7QUFIaUMsQ0FBcEM7O2tCQU1lSCxvQiIsImZpbGUiOiJwcm92aWRlci5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8qIGVzbGludC1kaXNhYmxlIHJlYWN0L2ZvcmJpZC1wcm9wLXR5cGVzICovXG5pbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnXG5pbXBvcnQgeyBmdW5jLCBub2RlIH0gZnJvbSAncHJvcC10eXBlcydcblxuZXhwb3J0IGNvbnN0IEZlYXR1cmVGbGFnc0NvbnRleHQgPSBSZWFjdC5jcmVhdGVDb250ZXh0KClcblxuY29uc3QgRmVhdHVyZUZsYWdzUHJvdmlkZXIgPSAoe1xuICBjaGlsZHJlbixcbiAgZ2V0RmVhdHVyZUZsYWcsXG4gIHRyYWNrRW5jb3VudGVyRmxhZyxcbn0pID0+IHtcbiAgcmV0dXJuIChcbiAgICA8RmVhdHVyZUZsYWdzQ29udGV4dC5Qcm92aWRlclxuICAgICAgdmFsdWU9e3sgZ2V0RmVhdHVyZUZsYWcsIHRyYWNrRW5jb3VudGVyRmxhZyB9fVxuICAgID5cbiAgICAgIHtjaGlsZHJlbn1cbiAgICA8L0ZlYXR1cmVGbGFnc0NvbnRleHQuUHJvdmlkZXI+XG4gIClcbn1cblxuRmVhdHVyZUZsYWdzUHJvdmlkZXIucHJvcFR5cGVzID0ge1xuICBnZXRGZWF0dXJlRmxhZzogZnVuYy5pc1JlcXVpcmVkLFxuICB0cmFja0VuY291bnRlckZsYWc6IGZ1bmMsXG4gIGNoaWxkcmVuOiBub2RlLmlzUmVxdWlyZWQsXG59XG5cbkZlYXR1cmVGbGFnc1Byb3ZpZGVyLmRlZmF1bHRQcm9wcyA9IHtcbiAgdHJhY2tFbmNvdW50ZXJGbGFnOiAoKSA9PiB7XG4gICAgLyogbm9vcCAqL1xuICB9LFxufVxuXG5leHBvcnQgZGVmYXVsdCBGZWF0dXJlRmxhZ3NQcm92aWRlclxuIl19